import { numberAttribute } from '@angular/core';

/** Input transform: '' / null / undefined -> null, anything else -> number. */
export function optionalNumber(value: unknown): number | null {
  return value == null || value === '' ? null : numberAttribute(value);
}
